import { render, staticRenderFns } from "./CardTotalKittingNeedApprove.vue?vue&type=template&id=c9cce098"
import script from "./CardTotalKittingNeedApprove.vue?vue&type=script&lang=js"
export * from "./CardTotalKittingNeedApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports